export const AUDIO_ANALYSIS_REGEX = /<user_audio_analysis>([\s\S]*?)<\/user_audio_analysis>/g;

/**
 * Filters out extra tags and their content if they are not relevant.
 * For <user_audio_analysis>, relevant content starts with "The speaker".
 * Refusals or irrelevant content are removed entirely.
 * Used in the backend to filter input to the LLM and database.
 */
export function filterExtraTags(content: string): string {
  if (typeof content !== 'string') return content;

  const filtered = content.replace(AUDIO_ANALYSIS_REGEX, (match, innerContent) => {
    const trimmedInner = innerContent.trim();
    if (trimmedInner.startsWith("The speaker")) {
      // Keep relevant analysis
      return match;
    } else {
      // Remove refusals or other content
      return "";
    }
  });

  return filtered.trim();
}

/**
 * Always strips out extra tags and their content.
 * Used in the frontend or whenever complete removal is required.
 */
export function stripExtraTags(content: string): string {
  if (typeof content !== 'string') return content;

  return content.replace(AUDIO_ANALYSIS_REGEX, "").trim();
}
